// extracted by mini-css-extract-plugin
export default {"platform":"PlatformPage_platform__3uWfq"};